import { Link } from "react-router-dom";

const Missing = () => {
  return (
    <>
    <div>404 Page</div>
    <div className="flexGrow">
        <Link to="/">Home</Link>
    </div>
  </>
  )
}

export default Missing